import AbstractCountrySelect from './AbstractCountry';
import { getCountryName } from '../../helpers/countryNames';
import { OECDRecipients } from '../../helpers/oecdCountries';

const selectOptions = (function buildOptions() {
  return OECDRecipients.map(code => ({
    value: code,
    label: getCountryName(code)
  }));
})();

class RecipientCountrySelect extends AbstractCountrySelect {
  name = "recipient-select-list";

  getOptions() {
    return selectOptions;
  }
}

export default RecipientCountrySelect;



// WEBPACK FOOTER //
// ./src/components/Selects/RecipientCountry.js